<template>
  <div class="tag" :class="{ 'two-words': text.split(' ').length == 2, 'three-words': text.split(' ').length == 3 }">
    <span class="percent">{{ percentage }}%</span>
    <span class="text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'CASH BACK'
    },
    percentage: {
      type: String,
      default: '5'
    }
  }
};
</script>

<style lang="scss" scoped>
$whiteColor: #fff;
$blueThemeColor: #0051ff;
.tag {
  font-family: 'Oblivian';
  background: $blueThemeColor;
  display: grid;
  gap: 5px;
  padding: 5px 6px;
  border-radius: 6px;
  text-align: justify;
  float: right;

  span {
    color: $whiteColor !important;
    line-height: 120% !important;
    font-weight: 400 !important;
    font-size: 24px !important;
    margin: auto;
    white-space: nowrap;
  }

  .text {
    font-size: 10px !important;
    font-weight: 300 !important;
    white-space: pre-line;
  }
}

.two-words {
  width: 92px;
  grid-template-columns: 1fr 1fr;
}

.three-words {
  width: 120px;
  grid-template-columns: 2fr 3fr;
}
</style>
